module.exports = __webpack_public_path__ + "static/media/ba.38a248a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ba.svg
// module id = 58
// module chunks = 0